import {Component, Input, Output, EventEmitter} from '@angular/core';
import { HttpService } from '../services/http/http.service';
import {MatDialog} from '@angular/material/dialog';
import {ImportazioneOperatoriComponent} from "../dialog/importazione-operatori/importazione-operatori.component";
import {ImportazioneSediComponent} from "../dialog/importazione-sedi/importazione-sedi.component";

@Component({
  selector: 'app-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss']
})
export class SearchboxComponent{
  @Input() title: any;
  @Input() data: any;
  @Input() name: any;
  @Input() isAssistenza: any;
  @Input() buttonText: string;
  @Output() searchContent = new EventEmitter<any>();
  @Output() newEvent = new EventEmitter<any>();
  minDateApprovazione:any;
  maxDateRiunione:any;
  formValues: any = {
    area:"",
    tipologia:"",
    descrizione:"",
    datepicker:"",
    sottoCategoria : "",
    stato: "",
    hasDigitalCompetence: false,
    hasGreenCompetence: false
   };

  constructor(
    public api:HttpService,
    public dialog: MatDialog,
  ) {}

  reset() {
    this.formValues = {
      area:"",
      tipologia:"",
      descrizione:"",
      datepicker:"",
      dataRiunione:"",
      dataApprovazione:"",
      nomeUtente:"",
      stato : "",
      cognomeUtente:"",
      codiceFiscale:"",
      sottoCategoria : "",

      hasDigitalCompetence: false,
      hasGreenCompetence: false
     };
  }
  loadContent(value: any) {

    let data = {
      value:value,
      name:this.name,
      isSearch: true,
      hasDigitalCompetence: this.formValues.hasDigitalCompetence,
      hasGreenCompetence: this.formValues.hasGreenCompetence
    }

    if(data.value.tipologia && data.value.tipologia.id != 1) {
      data.value.area = '';
    }

    this.searchContent.emit(data);
  }

  setMinApprovazione() {
      this.minDateApprovazione = this.formValues.dataRiunione;
  }

  setMaxRiunione() {
      this.maxDateRiunione = this.formValues.dataApprovazione;

  }

onDigitalToggleChange() {
    if (this.formValues.hasDigitalCompetence) {
      this.formValues.hasGreenCompetence = false; // Disattiva l'altro toggle se questo è attivo
    }
  }

  onGreenToggleChange() {
    if (this.formValues.hasGreenCompetence) {
      this.formValues.hasDigitalCompetence = false; // Disattiva l'altro toggle se questo è attivo
    }
  }

  showSubCategory(value: any, field: any) {
    let showHideClass;
    if(field.type=='select_sub') {
      showHideClass = (value.id == 1) ? field.cssClass + ' show' : field.cssClass + ' hide';
    }else if(field.type=='sottocategoria_comp_di_base') {
        showHideClass = (value.id == 3) ? field.cssClass + ' show' : field.cssClass + ' hide';
    }else if(field.type=='sottocategoria_comp_digitale') {
        showHideClass = (value.id == 6) ? field.cssClass + ' show' : field.cssClass + ' hide';
    }else {
      showHideClass = field.cssClass;
    }


    return showHideClass;
  }

  newDetail(event:any,id:any) {
    if(event != 'new_documento') {
      this.newEvent.emit(event);
    } else {
      let data = {
        name:event,
        id:id
      }
      this.newEvent.emit(data);
    }

  }

  scaricaAllegato() {
    this.api.downloadAllegato(this.formValues.tipoAllegato.id)
      .subscribe({
        next: (blob) => {

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `Allegato_${this.formValues.tipoAllegato.id}.pdf`;
          link.click();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error("Errore durante il download dell'allegato:", err);
        }
      });
  }


  importaSedi() {
    this.dialog.open(ImportazioneSediComponent, {
      height: '450px',
      width: '650px'
    });
  }

  importaOperatori() {
    this.dialog.open(ImportazioneOperatoriComponent, {
      height: '450px',
      width: '650px'
    });
  }
}
